import { render, staticRenderFns } from "./PublicUser.vue?vue&type=template&id=a1143628&scoped=true"
import script from "./PublicUser.vue?vue&type=script&lang=js"
export * from "./PublicUser.vue?vue&type=script&lang=js"
import style0 from "./PublicUser.vue?vue&type=style&index=0&id=a1143628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1143628",
  null
  
)

export default component.exports